import {React} from 'react';
import ReactDOM from "react-dom/client";
import {loadReCaptcha} from 'react-recaptcha-v3'
import ReactGA from 'react-ga'

import PageFaturaFacil from './pages/FaturaFacil'

import './styles/index.scss'

ReactGA.initialize('UA-28840052-1')

// load recaptcha
const recaptcha_site_key = process.env.REACT_APP_RECAPTCHA_CLIENT
loadReCaptcha(recaptcha_site_key, () => console.log(`recaptcha loaded`))

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <PageFaturaFacil />
);

